import React, { useState, useEffect } from 'react';
import { hasAcceptedAgreement, acceptAgreement } from '../services/api';
import Modal from '../components/Modal';
import UserAgreement from '../components/UserAgreement';
import './Dashboard.css';

const Dashboard = () => {
  const [hours, setHours] = useState(6);
  const [days, setDays] = useState(5);
  const [earnings, setEarnings] = useState(0);
  const [showAgreement, setShowAgreement] = useState(false);

  useEffect(() => {
    const checkAgreement = async () => {
      try {
        const response = await hasAcceptedAgreement();
        if (!response.data.has_accepted) {
          setShowAgreement(true);
        }
      } catch (error) {
        console.error('Failed to check agreement status', error);
      }
    };

    checkAgreement();
  }, []);

  useEffect(() => {
    const hourlyRate = 1.669;
    const dailyEarning = hours * hourlyRate;
    const weeklyEarning = dailyEarning * days;
    const monthlyEarning = weeklyEarning * 4; // Assuming 4 weeks a month
    setEarnings(monthlyEarning.toFixed(2));
  }, [hours, days]);

  const handleAcceptAgreement = async () => {
    try {
      await acceptAgreement();
      setShowAgreement(false);
    } catch (error) {
      console.error('Failed to accept agreement', error);
    }
  };

  return (
    <div className="dashboard-container">
      {showAgreement && (
        <Modal onClose={null}>
          <UserAgreement onAccept={handleAcceptAgreement} />
        </Modal>
      )}
      <h1>Dashboard</h1>
      <p>Welcome to your EarnGain dashboard!</p>

      <div className="calculator-container">
        <h2>Earnings Calculator</h2>
        <div className="form-group">
          <label>Hours per day (up to 6)</label>
          <input type="range" min="1" max="6" value={hours} className="slider" onChange={(e) => setHours(e.target.value)} />
          <span>{hours}</span>
        </div>
        <div className="form-group">
          <label>Days per week (up to 7)</label>
          <input type="range" min="1" max="7" value={days} className="slider" onChange={(e) => setDays(e.target.value)} />
          <span>{days}</span>
        </div>
        <div className="earnings-display">
          <p>Estimated Monthly Earnings: ${earnings}</p>
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
